import React from 'react';
import { Grid, Typography, Container } from '@material-ui/core';
import imagem from './image/img.png';
import CardInstituicoes from './CardIntituicoes';
import imagem2 from './image/img2.png';
import imagem3 from './image/img3.png';
import imagem4 from './image/img4.png';
import imagemEja from './image/eja.png';
import imagemTec from './image/tec.png';

const BackGroundCard = () => {
    return (
        <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
            style={{
                backgroundColor: '#48A2C8',
                width: '100%',
                height: 'auto',
                paddingBottom: '24px',
                borderRadius: '8px',
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                padding: '16px',
                boxSizing: 'border-box',
                overflow: 'hidden',
            }}
        >
      {/* Título acima dos cards */}
      <Container maxWidth={'md'} style={{ marginBottom: '20px' }}>
        <Typography variant="h4" style={{ color: '#FFFFFF', marginBottom: '16px', textAlign: 'center', fontFamily:'Public Sans', fontWeight:'600', fontSize:'36px' }}>
          Estamos presentes em todas as <br /> etapas de ensino
        </Typography>
      </Container>

            <Container maxWidth={'lg'}>
                <Grid container spacing={6} justifyContent="space-beetween"> {/* Ajuste para centralizar os cards */}
                    <Grid item xs={12} sm={6} md={4} container justifyContent='center'>
                        <CardInstituicoes image={imagem} tittle={'Educação infantil'} subtittle={'Pré-escola para crianças de 1 ano e 3 meses até os 5 anos de idade.'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} container justifyContent='center'>
                        <CardInstituicoes image={imagem2} tittle={'Ensino fundamental anos iniciais'} subtittle={'Do 1º ao 5º ano para crianças de 6 a 10 anos de idade.'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} container justifyContent='center'>
                        <CardInstituicoes image={imagem3} tittle={'Ensino fundamental anos finais'} subtittle={'Do 6º ao 9º ano para crianças de 11 a 15 anos de idade.'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} container justifyContent='center'>
                        <CardInstituicoes image={imagem4} tittle={'Ensino médio'} subtittle={'Da 1ª à 3ª série para alunos dos 15 anos até os 17 anos de idade.'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} container justifyContent='center'>
                        <CardInstituicoes image={imagemEja} tittle={'EJA - Educação de jovens e adultos'} subtittle={'Ensino fundamental e médio para jovens e adultos acima de 18 anos.'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} container justifyContent='center'>
                        <CardInstituicoes image={imagemTec} tittle={'Tecnólogo'} subtittle={'Educação Tecnológica para jovens aspirantes ao mercado de trabalho.'} />
                    </Grid>
                </Grid>
            </Container>
        </Grid>
    );
}

export default BackGroundCard;
